<template>
  <Transition name="drawer">
    <div v-if="visible" class="drawer" @click="$emit('close')">
      <div class="drawer__inner">
        <i
          class="ct-icon-close drawer__inner-close-icon"
          @click="$emit('close')"
        />
        <slot />
      </div>
    </div>
  </Transition>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AppDrawer',
  props: {
    visible: Boolean,
  },
  emits: ['close'],
})
</script>

<style lang="scss" scoped src="./Index.scss" />
